import { Component, Input, OnInit } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TitleCasePipe } from '@angular/common';

@Component({
	selector: 'au-benchmark-widget',
	templateUrl: './au-benchmark-widget.component.html',
	styleUrls: ['./au-benchmark-widget.component.scss'],
	imports: [MatTooltip, TitleCasePipe],
})
export class AuBenchmarkWidgetComponent implements OnInit {
	@Input()
	label = 'Benchmark';

	@Input()
	percentage = 0;

	/*
	 * This is the distance from side to center
	 * By default 50 is 0 on percentage rail as it's right in the middle
	 * The line will grow when the value will go to 0
	 * */
	leftProgress = 50;
	rightProgress = 50;

	constructor() {}

	ngOnInit() {
		this.calculateDistance();
	}

	calculateDistance() {
		if (this.percentage === 0) {
			return;
		}

		let absPercentageValue = Math.abs(this.percentage);
		// If the percentage is lower than 1% it will be very hard to see on
		// benchmark, so we need to make it at least 1% width
		if (absPercentageValue < 1) {
			absPercentageValue = 1;
		}
		const absCalcPercentageValue = 50 - absPercentageValue;
		const calculatedProgress = absPercentageValue > 50 ? 0 : absCalcPercentageValue;

		if (this.percentage < 0) {
			this.leftProgress = calculatedProgress;
		} else {
			this.rightProgress = calculatedProgress;
		}
	}
}
